var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCmcActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.409,
    height: 21.7,
    viewBox: "0 0 21.409 21.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.001,
    y1: 0.502,
    x2: 0.999,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3416b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e45f48"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cmc_active",
    transform: "translate(-1.3 -1.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_86802",
    "data-name": "\\uD328\\uC2A4 86802",
    d: "M19.9,14.3a1.287,1.287,0,0,1-1.2.1,1.874,1.874,0,0,1-.7-1.6V10.4c0-1.1-.4-2-1.2-2.2-1.3-.4-2.3,1.2-2.6,1.8L12,13.7V9.2c0-1-.4-1.6-1-1.8-.4-.1-1-.1-1.7.8L4.2,16.3a8.679,8.679,0,0,1-1-4.2,8.815,8.815,0,0,1,8.7-8.9,8.815,8.815,0,0,1,8.7,8.9h0a1.977,1.977,0,0,1-.7,2.2Zm2.8-2.1h0A10.82,10.82,0,0,0,12,1.3,10.82,10.82,0,0,0,1.3,12.2,10.734,10.734,0,0,0,12,23a10.54,10.54,0,0,0,7.3-2.9.967.967,0,0,0,0-1.4,1.071,1.071,0,0,0-1.4-.1h0a8.732,8.732,0,0,1-6,2.4,8.614,8.614,0,0,1-6.5-2.9L10,10.8v3.4c0,1.6.6,2.1,1.2,2.3.5.1,1.3,0,2.2-1.3l2.5-4.1c.1-.1.1-.3.2-.3v2.1a3.555,3.555,0,0,0,1.7,3.3,3.128,3.128,0,0,0,3.1-.1A4.338,4.338,0,0,0,22.7,12.2Z",
    fill: "url(#linear-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmcActive);
export default __webpack_public_path__ + "static/media/cmc_active.6b5858c75ca76b7d3781ca3ee897a1a0.svg";
export { ForwardRef as ReactComponent };